/*
 * @Author: likang xie
 * @Date: 2019-04-15 18:20:09
 * @Last Modified by: likang xie
 * @Last Modified time: 2019-04-17 20:20:45
 * @Purpose: 晒图路由
 */

export default [{
	title: '晒图有奖，每年销量10万套药考教材包邮免费送！',
	name: 'index'
}, {
	title: '晒图有奖，每年销量10万套药考教材包邮免费送！',
	name: 'detail'
}, {
	title: '上传晒图',
	name: 'upload'
}, {
	title: '榜单排名',
	name: 'ranking'
}]



// WEBPACK FOOTER //
// ./src/route/shareRouter.js